import { api } from '@/global/api'
import { GetFilterResponse } from '@/modules/accredited-establishments/api/types'

export const getPlansFilterOptions = async (): Promise<GetFilterResponse> => {
  const { data } = await api.get(
    '/site_accredited_network/filters/site_accredited_networks'
  )
  return data as GetFilterResponse
}
